export default "__VITE_ASSET__BztitR0C__"